'use strict';
import $ from 'jquery';
import templateHelper from './template-helper';
import login from './login';
import Cookies from 'js-cookie';

var carSearch = {
  _filtersForm: $('.filter-form'),
  _carList: $('#cars-search-results'),
  _orderSelect: $('.cars-search-order select'),
  _conditionRadio: $('input[name=condition]'),
  _carSearchURL: '/',
  _submitThrottle: null,
  _initiated: false,
  _greenLineButton: $('.greenlineCTA'),
  /**
   * Find out what the page url is supposed to be with the selected filters and order
   *
   * @return {string} new url
   * @example Audi/A4/?vaihteet=manuaali,automaatti&vetotapa=takaveto
   */
  _getURLFromForm: function () {
    var self = this,
      url = '',
      serializeObject = {};

    // Loop through filters and gather them in an object
    $.each(self._filtersForm.serialize().split('&'), function (i, v) {

      var [property, value] = v.split('=');

      if (typeof value !== 'string' || value === '') {
        // No value
        return true; // Continue $.each
      }

      if (typeof serializeObject[property] === 'undefined') {
        serializeObject[property] = [value];
      } else {
        serializeObject[property].push(value);
      }
    });

    // Remove unwanted stuff from object
    delete serializeObject.cm_token;

    // If no make is given, make sure there is no model, too
    if (typeof serializeObject.make === 'undefined') {
      delete serializeObject.model;
    }

    var urlParams = ['make'],
      getParams = '';

    // Parameters before '?'
    $.each(urlParams, function (i, property) {
      if (typeof serializeObject[property] !== 'undefined' && serializeObject[property].length > 0) {
        url += serializeObject[property] + '/';
      }
      delete serializeObject[property];
    });



    // Loop through the remaining parameters and build url after '?'
    $.each(serializeObject, function (property, values) {

      if (property === '' || values === '') {
        return true; // Continue $.each
      }

      // Skip default param for condition
      if (property === 'condition' && values.length === 1 && values[0] === 'all') {
        return true;
      }

      if (getParams !== '') {
        getParams += '&';
      }
      getParams += property + '=' + values.join(',');
    });

    // Add params after '?' to the url
    if (getParams !== '') {
      url += '?' + getParams;
    }

    return url;
  },

  /**
   * This function runs when filters change.
   * Change url, initiate ajax request, and possible other things
   *
   * @param {string} urlParams URL params for filters. If omitted, will get them from url.
   */
  _runFilters: function (urlParams) {

    // Update selected filters
    var urlParamsObj;
    if (typeof urlParams === 'undefined') {
      urlParams = this._getURLFromForm();

      urlParamsObj = this._urlToObj(urlParams);


      // Change url
      history.pushState({
        urlParams: urlParams
      }, '', this._carSearchURL + urlParams);
    }
    else {
      urlParamsObj = this._urlToObj(urlParams);

      // We are probably here because of a popstate event.
      // User is navigating in history, he didn't change filters manually.
      // That means we have to populate the filters.
      this._populateFilters(urlParamsObj);
    }

    // The first time the filters are run, we already have results from the server side
    if (!this._initiated) {

      // Set the initiated flag so results will be loaded on subsequent changes
      this._initiated = true;

    } else {

       // Do the AJAX dance
      $.ajax({
        url: '/api/1.0.0/products/',
        type: 'GET',
        contentType: 'application/json',
        data: urlParamsObj
      }).done((data, textStatus, jqxhr) => {
        if (data.status === 'OK') {
          this._renderCars(data);
        }
      }).fail((jqxhr, textStatus, errorThrown) => {
        // Server response can be found here: jqxhr.responseJSON;
      });

      this._populateSelectedFilters(this._urlToObj(urlParams));

      // Update title
      this._updateTitle(urlParams);
    }
  },

  /**
   *
   * Render car list
   *
   * @param {object} cars List of cars
   */
  _renderCars: function(cars){
    templateHelper.render('searchResults', cars, $('#cars-search-results'));
    this._updateDismantlePrices();
  },

  /**
   * Populate search filters
   * This is needed e.g. when user navigates back in history
   *
   * @param {object} paramsObj Optional, filter parameters to use in population. If omitted, current url params will be used
   */
  _populateFilters: function (paramsObj) {
    var self = this;

    if (typeof paramsObj === 'undefined') {
      paramsObj = self._urlToObj(self._getParamsFromURL());
    }

    // Change filter values according to urlParams
    self._filtersForm.find('input[name], select[name]').each(function () {
      var $this = $(this),
        inputName = $this.attr('name'),
        values = paramsObj[inputName],
        type = $this.is('select') ? 'select' : $this.attr('type');

      if (typeof values === 'undefined') {
        values = '';
      }

      switch (type) {
      case 'checkbox':
      case 'radio':
        if (typeof values === 'string') {
          values = values.split(',');
        }

        if (values.indexOf($this.val()) > -1) {
          $this.prop('checked', true);
        } else {
          $this.prop('checked', false);
        }
        break;
      case 'select':
      case 'text':
      case 'hidden':
        if (typeof values === 'object') {
          values = values.join();
        }

        $this.val(decodeURIComponent(values));
        break;
      }

      // Update model options after makeName is updated
      if (inputName === 'make') {
        //self._updateModelOptions();
      }
    });

    // filter count (not in use)
    //var numSelectedFilters = Object.keys(paramsObj).length;

    // Set order select
    if (paramsObj.hasOwnProperty('order_by')) {
      //numSelectedFilters--;
      let orderValue = paramsObj.order_by;

      if (paramsObj.hasOwnProperty('order_direction')) {
        //numSelectedFilters--;
        orderValue += '|' + paramsObj.order_direction;
      }

      this._orderSelect.val(orderValue);
    }
    else {
      $('option', this._orderSelect).first().prop('selected', true);
    }

    // Set the first condition radio as checked if no param
    if (!paramsObj.hasOwnProperty('condition')) {
      this._conditionRadio[0].checked = true;
    }

    // Update number of checked filters
    //$('.num-selected-filters').text(numSelectedFilters > 0 ? numSelectedFilters : '');
    //$('#search-watch .no-filters-disclaimer').toggleClass('hidden', numSelectedFilters > 0);

    // Update selected search filters list (the one above the results)
    this._populateSelectedFilters(paramsObj);
  },


  /**
   * Populate selected search filters list (the one above search results)
   *
   * @param {object} paramsObj Filter parameters to use in population.
   */
  _populateSelectedFilters: function(paramsObj) {
    // Format selected filters for template
    var selectedFilters = [];

    // Delete some unwanted params
    delete paramsObj.cm_edit;
    delete paramsObj.cm_token;

    // Combine min and max model year into one param
    paramsObj.Vuosimalli = [
      [
        paramsObj.minVuosimalli,
        paramsObj.maxVuosimalli
      ].filter(function(item){ return typeof item !== 'undefined'})
      .join('-')
    ];

    delete paramsObj.minVuosimalli;
    delete paramsObj.maxVuosimalli;

    // Remove order, we don't want that here
    delete paramsObj.jarjestys;

    $.each(paramsObj, function(field, values){
      let unit = '';

      switch (field) {
      case 'mittarilukema':
        unit = 'km';
        break;
      case 'hinta-liikkeessa':
        unit = '€';
        break;
      case 'teho1':
        unit = 'hv';
        break;
      case 'teho':
        unit = 'kW';
        break;
      case 'kulutus':
        unit = ' l/100km';
        break;
      }

      $.each(values, function(i, value){
        if (typeof value !== 'undefined' && value !== '') {
          selectedFilters.push({
            name: decodeURIComponent(field),
            value: value,
            label: decodeURIComponent(value) + unit
          });
        }
      });
    });

    // Render new list html
    //templateHelper.render('selectedFilters', { filters: selectedFilters }, $('#cars-search-selected-filters'));
  },

  /**
   * Clear filter after user clicks it in the selected filters list
   *
   * @param {object} event The click event
   */
  _resetSelectedFilter: function(event) {
    var $filter = $(event.currentTarget);
    var filterName = $filter.data('filter-name');
    var filterValue = $filter.data('filter-value');

    // Model year min and max are combined, reset both
    if (filterName === 'Vuosimalli') {
      this._resetInput('minVuosimalli');
      this._resetInput('maxVuosimalli');
    }
    else {
      this._resetInput(filterName, filterValue);
    }

    this._runFilters();
  },

  /**
   * Reset value of an input or select element
   *
   * @param {string} name  Name attribute of the element
   * @param {string} value Value of the element. Required only for checkboxes.
   */
  _resetInput: function(name, value) {
    var $filterInput = this._filtersForm.find('[name="' + name + '"]');
    if ($filterInput.attr('type') === 'checkbox') {
      $filterInput.filter('[value="' + value + '"]').prop('checked', false);
    }
    else {
      $filterInput.val('');
    }
  },

  /**
   * Update the page title according to search params
   *
   * @param {string} params Optional. The search params. If omitted, will get them from the form.
   */
  _updateTitle: function (params) {
    if (typeof params === 'undefined') {
      params = this._getURLFromForm();
    }

    var paramsObj = this._urlToObj(params);

    var $titleMake = $('.title-make');
    if (typeof paramsObj.make !== 'undefined') {
      $titleMake.text(decodeURIComponent(paramsObj.make));

      if (typeof paramsObj.model !== 'undefined') {
        $titleMake.next('.title-model').text(decodeURIComponent(paramsObj.model));
      } else {
        $titleMake.next('.title-model').empty();
      }
    } else {
      $titleMake.empty().next('.title-model').empty();
    }
  },

  /**
   * Get params from url and make an object out of it
   *
   * @param {string} url The url where the params are
   * @return {object}    The params in an object
   */
  _urlToObj: function (url) {
    let params = {};
    let [urlParams, getParams] = url.split('?');

    // Get make and model from the part before '?'
    urlParams = urlParams.split('/').filter(function (param) { return param.length > 0; });
    if (urlParams.length > 0) {
      params.make = urlParams[0].split(',');

      if (urlParams.length > 1) {
        params.model = urlParams[1].split(',');
      }
    }

    // Get params from the part after '?'
    if (typeof getParams === 'string' && getParams.length > 0) {
      getParams = getParams.split('&');

      for (let i = 0; i < getParams.length; i++) {
        let param = getParams[i].split('=');
        params[param[0]] = param[1].split(',');
      }
    }

    return params;
  },

  /**
   * Get current url params
   *
   * @return {string}
   * @example Audi/A4/?vaihteet=manuaali,automaatti&vetotapa=takaveto
   */
  _getParamsFromURL: function () {
    var locationHref = window.location.href;
    return locationHref.substring(locationHref.indexOf(this._carSearchURL) + this._carSearchURL.length);
  },

  /**
   * Order select element is outside of search form because of the UI
   * There's a hidden input in the form for the order
   * This function updates the hidden inputs value to match the UI element
   * and triggers change event
   */
  _updateOrderInput: function () {
    const separator = '|';
    let orderVal;

    if(this._orderSelect.val().indexOf(separator) > -1){
      orderVal = this._orderSelect.val().split('|');
      this._filtersForm.find('#search-order-direction').val(orderVal[1]);
      this._filtersForm.find('#search-order-value').val(orderVal[0]).change();
    }
    else {
      orderVal = this._orderSelect.val();
      this._filtersForm.find('#search-order-value').val(orderVal).change();
    }

  },

  _updateDismantlePrices: function() {
    if (!login.userIsDismantler()) {
      return;
    }

    const $itemsToUpdate = $('.item-lift-price-invisible');

    if ($itemsToUpdate.length > 0) {

      const itemPids = $.map($itemsToUpdate.closest('.item-lift'), function(el){
        return $(el).data('auction-id');
      });

      $.get('/api/1.0.0/products/prices?pids=' + itemPids.join(',')).done(result => {
        if (result.status === 'OK' && typeof result.prices === 'object' && result.prices) {
          $itemsToUpdate.each(function(){
            const $this = $(this);
            const pid = $this.closest('.item-lift').data('auction-id');
            if (result.prices[pid]) {
              templateHelper.render('itemsListPrice', { price: result.prices[pid] }, $this, 'replace');
              $this.removeClass('item-lift-price-invisible');
            }
          });
        }
      });
    }
  },

  /**
   * Initiate module
   */
  init: function () {
    if (this._filtersForm.length === 0 || this._filtersForm.hasClass('cars-search-dont-init')) {
      // There's no filters form on this page. This is not car search page. Don't initiate.
      return;
    }

    //this is just to show button and get correct count for greenline images
    if (login.userIsGreenlineDismantler()) {

      $.ajax({
        url: '/stage-ajax/getGreenlineData',
        type: 'GET',
        contentType: 'application/json',
      }).done((data, textStatus, jqxhr) => {
        this._greenLineButton.find('span').html(' &nbsp; ( ' + data.greenlineCount + ' )');
      }).fail((jqxhr, textStatus, errorThrown) => {
        // Server response can be found here: jqxhr.responseJSON;
      });

      this._greenLineButton.removeClass('d-none');
    }
    var self = this;

    this._populateFilters();
    this._updateDismantlePrices();

    // Add event listener for change in form or order
    self._filtersForm.on('change', 'input, select', function(){

      self._carList.prepend($('<div class="loader"></div>'));

      clearTimeout(self._submitThrottle);
      self._submitThrottle = setTimeout(self._runFilters.bind(self), 50);
    });

    // Add event listener to order change
    self._orderSelect.change(self._updateOrderInput.bind(self));

    // Add event listener to filter removal from selected filters list
    $('#cars-search-selected-filters').on('click', '.cars-search-selected-filter', this._resetSelectedFilter);

    // Trigger search when user goes back of forward in browser
    $(window).on('popstate', (e) => {
      this._carList.prepend($('<div class="loader"></div>'));

      if (
        typeof e.originalEvent !== 'undefined' &&
        typeof e.originalEvent.state !== 'undefined' &&
        e.originalEvent.state !== null &&
        typeof e.originalEvent.state.urlParams !== 'undefined'
      ) {
        this._runFilters(e.originalEvent.state.urlParams);
        return;
      }

      this._runFilters();
    });

    // Save search list to cookies for prev/next links on auction page
    if (typeof window.cookieSVTCarAuctionsList === 'string') {
      Cookies.set('svt-car-auctions-list', window.cookieHonkCarAuctionsList);
    }
  }
};

module.exports = carSearch;
